import { Link } from "react-router-dom";
import { useLang } from "../lang";
import { company } from "../data";

function Aboutpage() {
  const { t } = useLang();
  return (
    <>
      <section className="bg-white">
        <div className="wrap grid gap-10 py-12 md:grid-cols-2 md:items-center md:py-16">
          <div>
            <h1 className="text-3xl font-bold md:text-5xl">{t("เกี่ยวกับเรา", "About us")}</h1>
            <p className="mt-2 font-semibold text-gws-blue">{t(company.name)}</p>
            <p className="mt-6 text-lg text-ink-soft">
              {t(
                "เราเป็น System Integrator ที่ผลิตและติดตั้งระบบอัตโนมัติให้โรงงาน ทั้งสายพานลำเลียง ไลน์ผลิตที่ใช้หุ่นยนต์ และ AGV โดยเชี่ยวชาญไลน์ผลิตอาหารเป็นพิเศษ และรับงานไลน์อิเล็กทรอนิกส์และเกษตรกรรมด้วย พร้อมจัดหาอุปกรณ์ เครื่องมือ และอะไหล่ที่ใช้ในโรงงานตามความต้องการของลูกค้า",
                "We are a system integrator that builds and installs automation for factories: conveyors, robot-based production lines and AGVs. Food production lines are our speciality, and we also serve electronics and agriculture. We supply the equipment, tools and spare parts our customers' plants need."
              )}
            </p>
            <p className="mt-4 text-lg text-ink-soft">
              {t(
                "ทีมของเราออกแบบเครื่องให้เหมาะกับสินค้าแต่ละชนิด ผลิตเอง และติดตั้งได้รวดเร็ว รวมถึงระบบไฟ ตู้คอนโทรล และรางไฟภายในโรงงาน",
                "Our team designs each machine around the product it handles, builds it in-house and installs it quickly, along with the electrical systems, control cabinets and cable trays around it."
              )}
            </p>
          </div>
          <img src="/images/production-line.webp" alt={t("ไลน์ผลิตในโรงงานลูกค้า", "A production line at a customer plant")} className="aspect-[4/3] w-full rounded-lg object-cover" />
        </div>
      </section>

      <section className="wrap py-14">
        <blockquote className="max-w-3xl text-2xl font-semibold leading-snug md:text-3xl">
          {t("“สนับสนุนให้พันธกิจของลูกค้าบรรลุสู่ความสำเร็จ”", "“Helping our customers' missions succeed.”")}
        </blockquote>
        <div className="mt-10 grid gap-6 sm:grid-cols-2">
          <img src="/images/mesh-conveyor.webp" alt={t("สายพาน wire-mesh สแตนเลส", "Stainless wire-mesh conveyor")} loading="lazy" className="aspect-[4/3] w-full rounded-lg object-cover" />
          <img src="/images/cleated-conveyor.webp" alt={t("สายพานยกขึ้นในห้องผลิตอาหาร", "Cleated incline conveyor in a food room")} loading="lazy" className="aspect-[4/3] w-full rounded-lg object-cover" />
        </div>
        <Link to="/contact" className="btn-primary mt-10">{t("ติดต่อเรา", "Contact us")}</Link>
      </section>
    </>
  );
}

export default Aboutpage;
